import { Directive, Input, ElementRef, OnInit, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appHtmlTooltip]'
})
export class HtmlTooltipDirective implements OnInit, OnDestroy {
  @Input() appHtmlTooltip: string = '';
 
  private tooltipElement: HTMLElement | null = null;
  private mouseEnterListener: (() => void) | null = null;
  private mouseLeaveListener: (() => void) | null = null;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.mouseEnterListener = this.renderer.listen(
      this.elementRef.nativeElement,
      'mouseenter',
      () => this.show()
    );
    this.mouseLeaveListener = this.renderer.listen(
      this.elementRef.nativeElement,
      'mouseleave',
      () => this.hide()
    );
  }

  ngOnDestroy(): void {
    if (this.mouseEnterListener) this.mouseEnterListener();
    if (this.mouseLeaveListener) this.mouseLeaveListener();
    this.hide();
  }

  private show(): void {
  if (this.tooltipElement) {
    return;
  }

  // Create tooltip element
  this.tooltipElement = this.renderer.createElement('div');
  this.renderer.addClass(this.tooltipElement, 'custom-html-tooltip');
  this.tooltipElement.innerHTML = this.appHtmlTooltip;

  // Set initial opacity for animation
  this.renderer.setStyle(this.tooltipElement, 'opacity', '0');
  this.renderer.setStyle(this.tooltipElement, 'transform', 'translateX(-4px)');

  // Append to body
  this.renderer.appendChild(document.body, this.tooltipElement);

  // Calculate position after appending to get accurate dimensions
  const hostRect = this.elementRef.nativeElement.getBoundingClientRect();
  const tooltipRect = this.tooltipElement.getBoundingClientRect();
  
  // Position to the right of the icon with 8px gap
  const left = hostRect.right + 8;
  // Align top of tooltip with top of icon (or slightly below)
  const top = hostRect.top + 12;

  this.renderer.setStyle(this.tooltipElement, 'position', 'fixed');
  this.renderer.setStyle(this.tooltipElement, 'left', `${left}px`);
  this.renderer.setStyle(this.tooltipElement, 'top', `${top}px`);
  this.renderer.setStyle(this.tooltipElement, 'z-index', '10000');
  this.renderer.setStyle(this.tooltipElement, 'margin', '0');

  // Check if tooltip goes off-screen and adjust
  const viewportWidth = window.innerWidth;
  if (left + tooltipRect.width > viewportWidth - 16) {
    // Position to the left of the icon instead
    const adjustedLeft = hostRect.left - tooltipRect.width - 8;
    this.renderer.setStyle(this.tooltipElement, 'left', `${adjustedLeft}px`);
    this.renderer.setStyle(this.tooltipElement, 'transform', 'translateX(4px)');
  }

  // Trigger animation
  setTimeout(() => {
    if (this.tooltipElement) {
      this.renderer.setStyle(this.tooltipElement, 'opacity', '1');
      this.renderer.setStyle(this.tooltipElement, 'transform', 'translateX(0)');
    }
  }, 10);
}

  private hide(): void {
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
      this.tooltipElement = null;
    }
  }
}